import { DialogComponent } from '@theme/dialog';

class CCMobileMenu extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('dialog:open', this.#onOpen);
    this.addEventListener('dialog:close', this.#onClose);
    this.addEventListener('click', this.#onNavigate);
    window.addEventListener('resize', this.#onResize);
  }

  disconnectedCallback() {
    this.removeEventListener('dialog:open', this.#onOpen);
    this.removeEventListener('dialog:close', this.#onClose);
    this.removeEventListener('click', this.#onNavigate);
    window.removeEventListener('resize', this.#onResize);
    super.disconnectedCallback();
  }

  #onOpen = () => {
    this.querySelector('[data-cc-menu-trigger]')?.setAttribute('aria-expanded', 'true');
  };

  #onClose = () => {
    this.querySelector('[data-cc-menu-trigger]')?.setAttribute('aria-expanded', 'false');
  };

  #onResize = () => {
    requestAnimationFrame(() => {
      if (!this.isConnected || !this.refs.dialog.open) return;
      const container = this.closest('.header__drawer');
      if (container && getComputedStyle(container).display === 'none') this.closeDialog();
    });
  };

  #onNavigate = async (event) => {
    if (!(event.target instanceof Element) || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!(link instanceof HTMLAnchorElement) || !this.refs.dialog.contains(link)) return;
    if (link.target === '_blank' || link.hasAttribute('download')) return;
    event.preventDefault();
    await this.closeDialog();
    window.location.assign(link.href);
  };
}

if (!customElements.get('cc-mobile-menu')) customElements.define('cc-mobile-menu', CCMobileMenu);
